import React from 'react';

class Translate extends React.Component{
	changeLanguage(value){
		const {i18n} = this.props;
		localStorage.setItem('language', value)
		i18n.changeLanguage(value);
	}

	render(){
		return(
			<div className="language_login">
				<ul className="m-nav-sticky-h">
					<li className="m-nav-sticky-h__item">
						<img onClick={this.changeLanguage.bind(this, 'en')} src="assets/img/flags/020-flag.svg" alt="en"/>
					</li>
					<li className="m-nav-sticky-h__item">
						<img onClick={this.changeLanguage.bind(this, 'vi')} src="assets/img/flags/flag_vietnam.png" alt="vn"/>
					</li>
					<li className="m-nav-sticky-h__item">
						<img onClick={this.changeLanguage.bind(this, 'fr')} src="assets/img/flags/flag_french.png" alt="fr"/>
					</li>
				</ul>
			</div>
			);
	}
}

export default Translate